import { useState, useEffect, useCallback } from 'react';
import { useModals, Modal } from '.';

// Hooks
import useDebounce from '../../hooks/debounce';

export const ModalLayer = ({ data: contextModalData, layer }) => {
	const { config, closeModal: closeModalOnContext } = useModals();

	const [show, setShow] = useState(false);

	const [modalData, setModalData] = useState(false);
	const debouncedModalData = useDebounce(modalData);

	useEffect(() => {
		if(contextModalData) {
			openModal(contextModalData)
		}
		else {
			closeModal();
		}
	}, [contextModalData])

	useEffect(() => {
		if(!debouncedModalData) {
			closeModalOnContext(layer);
		}
	}, [debouncedModalData, layer])

	const closeModal = useCallback(() => {
		return new Promise(resolve => {
			if(modalData) {
				setShow(false);

				setTimeout(() => {
					if(modalData?.modalProps?.onClose) {
						modalData.modalProps.onClose();
					}
					setModalData(false);
					setTimeout(() => {
						resolve();
					}, [config.transitionTimeout])
				}, [config.modalOutTime + config.transitionTimeout])
			}
			else {
				resolve();
			}
		});
	}, [modalData, layer]);

	const openModal = useCallback((newModalData) => {
		closeModal().then(() => {
			setModalData(newModalData);
		})
	}, [closeModal]);

	const onChildModalInitialize = useCallback(() => {
		setShow(true);

		if(modalData.onShow) {
			modalData.onShow();
		}
		if(modalData.onShown) {
			setTimeout(() => {
				modalData.onShown();
			}, modalInTime)
		}
	}, [config, modalData]);

	if(modalData) {
		return (
			<Modal
				modalData={modalData}
				layer={layer}
				show={show}
				close={closeModal}
				onInitialize={onChildModalInitialize} />
		)
	}
}